import DashInfoCardDetails from './DashInfoCardDetails';
export default DashInfoCardDetails;
export { default as DashInfoCardDetails } from './DashInfoCardDetails';